import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxFormModule,
  DxSelectBoxModule,
  DxTagBoxModule,
  DxTemplateModule,
  DxTextBoxModule,
  DxToastModule,
  DxValidationGroupModule,
  DxValidatorModule,
} from 'devextreme-angular';
import { ConfigService } from 'src/app/services/config.service';
import { ContactService } from 'src/app/services/contact.service';
import { GridConnectionService } from 'src/app/services/grid-connection.service';
import { AppGlobals } from '../../app.globals';
import { GpdButtonComponent } from '../gpd-button/gpd-button.component';

import { SearchableDropdownDirective } from '../../directives/searchable-dropdown.directive';
@Component({
    selector: 'app-contacts-add-company-inline',
    imports: [
        CommonModule,
        DxFormModule,
        DxTagBoxModule,
        DxTextBoxModule,
        DxToastModule,
        DxValidatorModule,
        DxSelectBoxModule,
        DxTemplateModule,
        DxValidationGroupModule,
        GpdButtonComponent,
        SearchableDropdownDirective,
    ],
    templateUrl: './contacts-add-company-inline.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./contacts-add-company-inline.component.css']
})
export class ContactsAddCompanyInlineComponent implements OnInit {
  @ViewChild('companyForm') companyForm;

  type: any = '';
  message: any = '';
  toastVisible: boolean = false;

  formData = {
    id: null,
    name: null,
    tags: null,
    address: null,
    addition: null,
    city: null,
    zipcode: null,
    country: null,
    countryId: null,
    stateId: null,
    phone: null,
  };

  @Input() prePopulatePartner: boolean;

  contactTags: any;
  countriesByLanguageList: any = [];

  @Output() onSubmit = new EventEmitter<any>();
  @Output() onAbort = new EventEmitter<any>();

  constructor(
    private configService: ConfigService,
    private contactService: ContactService,
    private gridConnectionService: GridConnectionService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.contactTags = await this.configService.loadContactTags();
    this.getCountriesByLanguage();
    if (this.prePopulatePartner === true) {
      this.formData.tags = [100];
    }
  }

  handleSubmitButton(event: any): void {
    const result = this.companyForm.instance.validate();
    if (result.isValid) {
      this.handleSubmit(event);
    }
  }

  handleAbort(): void {
    this.onAbort.emit();
  }

  handleSubmit(e: any): void {
    if (this.formData.name != '' && this.formData.name != null) {
      this.contactService.addCompany(this.formData).then(
        result => {
          if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
          else {
            this.onSubmit.emit({ data: result.companyItems[0] });
            this.saveToast({ type: true, feedback: $localize`:@@saved:Saved` });
          }
        },
        (error: any) => {
          AppGlobals.ShowErrorMessage(error);
        }
      );
    }
  }

  saveToast(e: any): void {
    const type = e.type ? 'success' : 'error';
    this.type = type;
    this.message = e.feedback;
    this.toastVisible = true;
  }

  getCountriesByLanguage(): void {
    this.gridConnectionService.getCountries({}).then(
      result => {
        if (result.hasError === true) AppGlobals.ShowErrorMessage(result.feedback);
        else this.countriesByLanguageList = result.countryList;
      },
      (error: any) => AppGlobals.ShowErrorMessage(error)
    );
  }

  handleCountryChange(e: any): void {}
}
